module.exports = __webpack_public_path__ + "img/Ma.Maritime.Diaphragmwall.Diaphragmwall-RetainedHeight27m.Concrete.50d275d0.png";